import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }

import { useI18n } from 'vue-i18n'
import LanguageSwitch from '@/components/controls/LanguageSwitch.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TheHeader',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_unref(t)('connection.discover.title')), 1),
    _createVNode(LanguageSwitch)
  ]))
}
}

})